"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Parser = exports.TagElementWithAttributes = exports.TagElement = exports.TagElementType = void 0;
var types_1 = require("./types");
var TagElementType;
(function (TagElementType) {
    TagElementType[TagElementType["Open"] = 0] = "Open";
    TagElementType[TagElementType["Close"] = 1] = "Close";
})(TagElementType = exports.TagElementType || (exports.TagElementType = {}));
var TagElement = /** @class */ (function () {
    function TagElement(tag, type) {
        this.tag = tag;
        this.type = type;
    }
    return TagElement;
}());
exports.TagElement = TagElement;
var TagElementWithAttributes = /** @class */ (function (_super) {
    __extends(TagElementWithAttributes, _super);
    function TagElementWithAttributes(tag, type) {
        var _this = _super.call(this, tag, type) || this;
        _this.attributes = {};
        return _this;
    }
    TagElementWithAttributes.prototype.setAttribute = function (name, value) {
        this.attributes[name] = value;
        return this;
    };
    return TagElementWithAttributes;
}(TagElement));
exports.TagElementWithAttributes = TagElementWithAttributes;
var Parser = /** @class */ (function () {
    function Parser(buffer) {
        this.buffer = buffer;
        this.index = 0;
    }
    Parser.prototype.skipWhitespace = function () {
        for (; this.index < this.buffer.length && this.buffer[this.index] === ' '; this.index++)
            ;
    };
    Parser.prototype.parseName = function () {
        var startIndex = this.index;
        for (; this.index < this.buffer.length && /[a-z-]/.test(this.buffer[this.index]); this.index++)
            ;
        return this.buffer.slice(startIndex, this.index);
    };
    Parser.prototype.parseHexCode = function () {
        var startIndex = this.index;
        for (; this.index < this.buffer.length &&
            /[0-9a-f]/i.test(this.buffer[this.index]); this.index++)
            ;
        return this.buffer.slice(startIndex, this.index);
    };
    Parser.prototype.parseValue = function () {
        var startIndex = this.index;
        if (this.buffer[this.index] === '"') {
            startIndex++;
            this.index++;
            for (; this.index < this.buffer.length && this.buffer[this.index] !== '"'; this.index++)
                ;
            this.index++;
            return this.buffer.slice(startIndex, this.index - 1);
        }
        else if (this.buffer[this.index] === '#') {
            this.index++;
            return '#' + this.parseHexCode();
        }
        for (; this.index < this.buffer.length &&
            this.buffer[this.index] !== ' ' &&
            this.buffer[this.index] !== '>'; this.index++)
            ;
        return this.buffer.slice(startIndex, this.index);
    };
    Parser.prototype.parseOpeningTag = function () {
        this.skipWhitespace();
        if (this.buffer[this.index] === '#') {
            this.index++;
            var tagElement_1 = new TagElementWithAttributes(types_1.Tag.Color, TagElementType.Open);
            tagElement_1.setAttribute('value', '#' + this.parseHexCode());
            return tagElement_1;
        }
        var tag = this.parseName();
        if (!types_1.allTags.includes(tag)) {
            return null;
        }
        if (!types_1.tagsWithValue.includes(tag)) {
            return new TagElement(tag, TagElementType.Open);
        }
        var tagElement = new TagElementWithAttributes(tag, TagElementType.Open);
        if (this.buffer[this.index] === '=') {
            this.index++;
            tagElement.setAttribute('value', this.parseValue());
            this.skipWhitespace();
        }
        while (this.index < this.buffer.length && this.buffer[this.index] !== '>') {
            var attributeName = this.parseName();
            if (attributeName === '')
                return null;
            if (this.buffer[this.index] !== '=')
                return null;
            this.index++;
            var attributeValue = this.parseValue();
            tagElement.setAttribute(attributeName, attributeValue);
            this.skipWhitespace();
        }
        return tagElement;
    };
    Parser.prototype.parseClosingTag = function () {
        this.skipWhitespace();
        var tag = this.parseName();
        if (!types_1.allTags.includes(tag)) {
            return null;
        }
        this.skipWhitespace();
        return new TagElement(tag, TagElementType.Close);
    };
    Parser.prototype.next = function () {
        var startIndex = this.buffer.indexOf('<', this.index);
        if (startIndex === -1) {
            return {
                isEnd: true
            };
        }
        this.index = startIndex + 1;
        var element;
        if (this.buffer[this.index] === '/') {
            this.index++;
            element = this.parseClosingTag();
        }
        else {
            element = this.parseOpeningTag();
        }
        if (element === null) {
            return {
                isEnd: false
            };
        }
        if (this.buffer[this.index] !== '>') {
            return {
                isEnd: false
            };
        }
        this.index++;
        return {
            item: {
                element: element,
                raw: this.buffer.slice(startIndex, this.index),
                start: startIndex,
                end: this.index
            },
            isEnd: false
        };
    };
    return Parser;
}());
exports.Parser = Parser;
//# sourceMappingURL=parser.js.map